/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Button, Loader } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';
import { useFormikContext, FieldArray } from 'formik';
import { BsPlusCircle } from 'react-icons/bs';
import { useHistory } from 'react-router-dom';

// Internal deps

import AddWellForm from '../Wells/AddWellForm/AddWellForm';
import { getImputationType, getWellsAsociatedWithLocation } from '../../services/yclickMaster';
import useToast from '../../hooks/useToast';
import ItemWell from '../Wells/ItemWell/ItemWell';
import { ubicationTypeEnum } from '../../utils/dataStatus';

const AccountAssignmentObject = (props) => {
  const {
    titleWells,
    setHasError,
    disabledAddWell,
    disabledImputationForm,
    ubicationType,
    readOnly,
    bussinesUnitId,
    locationId,
    eventId,
    imputationObjectDefault,
    logicDeleted,
    monthlyImputationObject,
    typeOfEventId,
    showDetailWell,
    createSDS,
    fromPteAuthorization,
    formRef,
    setDisabledActions
  } = props;

  const { values, setFieldValue, errors } = useFormikContext();
  const [loader, setLoader] = useState(false);
  const [params, setParams] = useState({
    optionsImputationType: [],
    optionsWell: [],
    optionsEvent: [],
    optionsTeam: [],
    optionsImputationObject: []
  });
  const [wellOptions, setWellOptions] = useState([]);
  const [showAddWellForm, setShowAddWellForm] = useState(false);
  const history = useHistory();

  const isSdSDetail = history.location.pathname.split('/')[1] === 'detail';

  useEffect(() => {
    if (errors?.imputationObject?.wells?.length) {
      setHasError(true);
    } else {
      setHasError(false);
    }
  }, [errors]);

  const { setNewToast } = useToast();

  const getImputationTypeOptions = async () => {
    try {
      const imputationTypeResult = await getImputationType();

      setParams({
        ...params,
        optionsImputationType: imputationTypeResult
      });
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    }
  };

  const getWellOptions = async () => {
    try {
      const res = await getWellsAsociatedWithLocation(locationId, typeOfEventId);

      const wellsOpt = res?.map((item) => ({
        ...item,
        label: item?.nombre,
        value: item?.id
      }));

      const commonsOptions = values.imputationObject?.wells
        .filter((well) => wellsOpt.some((option) => option?.value === well?.well?.value))
        .map((well) => well.well);

      const uniqueOptionsWells = wellsOpt.filter(
        (well) =>
          !values.imputationObject?.wells.some((option) => option?.well?.value === well?.value)
      );

      setParams((param) => ({
        ...param,
        optionsWell: uniqueOptionsWells
      }));
      setWellOptions(commonsOptions);
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const removeWellSelected = (val) => {
    setParams({ ...params, optionsWell: [...params.optionsWell, val.well] });
    setWellOptions((prevOptions) => prevOptions.filter((w) => w.id !== val.well.id));
  };

  const addWellSelected = (val) => {
    setParams({ ...params, optionsWell: params.optionsWell.filter((w) => w.id !== val.well.id) });
    setWellOptions([...wellOptions, val.well]);
  };

  const handleCloseAddWellForm = () => {
    setShowAddWellForm((oldValue) => !oldValue);
  };

  const handleLoading = (value) => {
    setLoader(value);
  };

  useEffect(() => {
    getImputationTypeOptions();
  }, []);

  useEffect(() => {
    if (typeOfEventId) {
      getWellOptions();
    }
  }, [typeOfEventId]);

  const compareObjects = () => {
    const wells = values?.imputationObject?.wells;
    const copyWells = values?.imputationObject?.copyWells;
    const hasImputationObject = values?.imputationObject?.wells?.some(
      (impObj) => impObj.imputationObject === null
    );

    if (wells?.length > 0 && copyWells?.length > 0) {
      const areEqual = wells?.every(
        (well, index) =>
          well?.imputationObject?.id === copyWells[index]?.imputationObject?.id &&
          well?.imputationType?.id === copyWells[index]?.imputationType?.id &&
          well?.eliminado === copyWells[index]?.eliminado
      );

      if (areEqual || hasImputationObject) {
        setDisabledActions(true);
      } else {
        setDisabledActions(false);
      }
    }
  };

  useEffect(() => {
    // Este useffect es para limpiar el evento cuando se borran todos los pozos en una locacion
    // y que este no trabe la validacion de eventos iguales
    if (!values?.imputationObject?.wells?.length) {
      setFieldValue('ubication.event', null);
    }
  }, []);

  useEffect(() => {
    compareObjects();
  }, [values]);

  return (
    <>
      {loader && <Loader show={loader} text="CARGANDO ..." />}
      <FieldArray name="imputationObject.wells">
        {({ insert, remove }) => (
          <div>
            {showAddWellForm && !values.isOyM && (
              <AddWellForm
                businessUnit={values.ubication.uunn?.id || bussinesUnitId}
                createSDS={createSDS}
                eventId={eventId}
                fromPteAuthorization={fromPteAuthorization}
                handleAddWell={(valuesWellForm) => {
                  insert(0, valuesWellForm);
                  addWellSelected(valuesWellForm);
                }}
                imputationObjectDefault={imputationObjectDefault}
                onCloseForm={handleCloseAddWellForm}
                params={params}
                setLoading={handleLoading}
                typeOfEventId={typeOfEventId}
                ubicationId={values.ubication.ubication?.id || locationId}
                wells={values.imputationObject?.wells}
              />
            )}
            {!values.isOyM && !fromPteAuthorization && (
              <>
                <div className="d-flex justify-content-between">
                  <h5>
                    {titleWells ||
                      (ubicationType?.id === ubicationTypeEnum.locacion ? 'Pozos' : 'Pozo')}
                  </h5>
                  {!showAddWellForm &&
                    ubicationType?.id === ubicationTypeEnum.locacion &&
                    values.imputationObject.editaPozosLocacion !== false &&
                    // maxCantWells !== values.imputationObject.wells.length &&
                    !readOnly && (
                      <Button
                        colorIcon="light"
                        disabled={
                          disabledAddWell || (createSDS && params.optionsWell?.length === 0)
                        }
                        fontSizeLabel="14px"
                        icon={BsPlusCircle}
                        iconRight
                        label="Agregar pozo"
                        onClick={() => setShowAddWellForm((oldValue) => !oldValue)}
                        sizeIcon="17px"
                        type="button"
                        variant="primary"
                        widthButton="180px"
                      />
                    )}
                </div>
                <hr />
              </>
            )}
            {showDetailWell &&
              values.imputationObject?.wells?.map((well, index) =>
                well.eliminado ? null : (
                  <ItemWell
                    createSDS
                    disabledAllEdition={showAddWellForm || readOnly}
                    disabledDeleteWellButton={
                      ((values.imputationObject?.wells.length <= 1 ||
                        values.imputationObject?.wells.filter((w) => !w.eliminado).length <= 1 ||
                        disabledAddWell ||
                        values.imputationObject.editaPozosLocacion === false) &&
                        (isSdSDetail || monthlyImputationObject)) ||
                      fromPteAuthorization
                    }
                    disabledImputationForm={disabledImputationForm || imputationObjectDefault}
                    formRef={formRef}
                    fromPteAuthorization={fromPteAuthorization}
                    index={index}
                    key={well.well?.id}
                    logicDeleted={logicDeleted}
                    params={params}
                    removeWell={() => {
                      remove(index);
                      removeWellSelected(well);
                    }}
                    removeWellSelected={removeWellSelected}
                    setLoading={handleLoading}
                    showAlertWell={showAddWellForm}
                    showDetailWell
                    well={well}
                  />
                )
              )}
          </div>
        )}
      </FieldArray>
    </>
  );
};

AccountAssignmentObject.propTypes = {
  titleWells: PropTypes.string,
  disabledAddWell: PropTypes.bool,
  disabledImputationForm: PropTypes.bool,
  ubicationType: PropTypes.shape({
    id: PropTypes.number,
    value: PropTypes.number
  }).isRequired,
  readOnly: PropTypes.bool,
  bussinesUnitId: PropTypes.number,
  locationId: PropTypes.number,
  eventId: PropTypes.number,
  imputationObjectDefault: PropTypes.bool,
  logicDeleted: PropTypes.bool,
  monthlyImputationObject: PropTypes.bool,
  typeOfEventId: PropTypes.number.isRequired,
  showDetailWell: PropTypes.bool,
  createSDS: PropTypes.bool,
  fromPteAuthorization: PropTypes.bool,
  formRef: PropTypes.objectOf(PropTypes.shape),
  setHasError: PropTypes.func,
  setDisabledActions: PropTypes.func
};
AccountAssignmentObject.defaultProps = {
  titleWells: null,
  monthlyImputationObject: false,
  disabledAddWell: false,
  disabledImputationForm: false,
  readOnly: false,
  bussinesUnitId: null,
  locationId: null,
  eventId: null,
  imputationObjectDefault: false,
  logicDeleted: true,
  showDetailWell: false,
  createSDS: false,
  fromPteAuthorization: false,
  formRef: {},
  setHasError: () => {},
  setDisabledActions: () => {}
};

export default AccountAssignmentObject;
